export var getShadeBackground = function getShadeBackground(shade, theme) {
  var hexColors = shade.hexColors,
    imageUrl = shade.imageUrl;
  if ((hexColors === null || hexColors === void 0 ? void 0 : hexColors.length) === 1 && hexColors[0]) {
    return hexColors[0];
  }
  if (hexColors && hexColors.length > 1) {
    return "linear-gradient(to right, ".concat(hexColors[0], ", ").concat(hexColors[0], " 50%, ").concat(hexColors[1], " 50%)");
  }
  if (imageUrl) {
    return "url(".concat(imageUrl, ")");
  }
  return theme.palette.common.white;
};
//# sourceMappingURL=getShadeBackground.js.map